<script setup>
import {computed, onMounted, reactive} from "vue";
import axios from "axios";
import url from "@/config/urls";
import router from "@/router/index.js";
import { useRoute } from "vue-router";
import Password from "@components/parts/Password.vue";

const route = useRoute();
// URLパラメータからトークンを取得する
const token = computed(() => route.params.token);

const props = defineProps({
  passwordResetApiUrl : {type: String, default: url.api.passwordReset},
  resetPasswordCompletePageUrl: {type: String, default: url.page.passwordReset.resetPasswordComplete},
  errorPageUrl: {type: String, default: url.error}
});

const input = reactive({
  password: '',
  password_confirm: ''
});

const errorMessage = reactive({
  password: '',
  password_confirm: ''
});



onMounted(async() => {
  if(!token.value) {
    sessionStorage.setItem('errorHeading', 'お探しのページは見つかりませんでした。');
    sessionStorage.setItem('errorBody', 'お探しのページは移動もしくは削除されたか、URLが誤っている可能性があります。最新の情報はトップページよりご覧ください。');
    router.push('/error');
    return;
  }
})

const mapResponseError = (response, fieldList) => {
  return response.data.error
  .map(errorObject => fieldList.includes(errorObject.field) ? errorObject.message : null)
  .filter(item => item !== null)
  .join('\n');
}

// バリデーションチェック
const validatePassword = (password) => {
  if (!password) {
    errorMessage.password = '新しいパスワードを入力してください。';
  } else if (password.length < 8) {
    errorMessage.password = '新しいパスワードは8文字以上で入力してください。';
  } else if (password.length > 255) {
    errorMessage.password = '新しいパスワードは255文字以内で入力してください。';
  } else if (!password.match(/^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]{8,255}$/)) {
    errorMessage.password = 'パスワードに使用できない文字が含まれています。';
  } else if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/)) {
    errorMessage.password = '英字大文字、英字小文字、数字、いずれも含むパスワードを設定してください。';
  } else {
    errorMessage.password = '';
  }
}

const validatePasswordConfirm = (password, password_confirm) => {
  if (!password_confirm) {
    errorMessage.password_confirm = '新しいパスワード(確認用)を入力してください。';
  } else if (password !== password_confirm) {
    errorMessage.password_confirm = '新しいパスワードと新しいパスワード(確認用)に入力された値が一致していません。';
  } else {
    errorMessage.password_confirm = '';
  }
}

// 送信ボタン押下時
const onClickUpdateButton = () => {
  // バリデーションチェック
  validatePassword(input.password);
  validatePasswordConfirm(input.password, input.password_confirm);
  if (errorMessage.password || errorMessage.password_confirm) {
    return;
  }
  // パスワード再設定APIの呼び出し
  const param = {
    passwordResetToken: token.value,
    password: input.password
  }
  axios.post(props.passwordResetApiUrl, param)
    .then(response => {
      if (response.data.response.updated) {
        router.push(props.resetPasswordCompletePageUrl);
      } else {
        errorMessage.current =
          response.data.error.map(errorObject => errorObject.message).join('\n');
      }
    })
    .catch(error => {
      const response = error.response;
      switch (response.status) {
        case 400:
          if (response.data.error instanceof Array) {
            errorMessage.password = mapResponseError(response, ['password']);
            if (!errorMessage.password){
              sessionStorage.setItem('errorHeading', '指定されたページを表示できません。');
              sessionStorage.setItem('errorBody', '申し訳ございませんが、リクエストを正しく処理できませんでした。送信内容が正確であることを確認し、もう一度お試しください。');
              router.push(props.errorPageUrl);
            }
          } else {
            sessionStorage.setItem('errorHeading', '指定されたページを表示できません。');
            sessionStorage.setItem('errorBody', '申し訳ございませんが、リクエストを正しく処理できませんでした。送信内容が正確であることを確認し、もう一度お試しください。');
            router.push(props.errorPageUrl);
          }
          break;
        case 404:
          sessionStorage.setItem('errorHeading', 'お探しのページは見つかりませんでした。');
          sessionStorage.setItem('errorBody', 'お探しのページは移動もしくは削除されたか、URLが誤っている可能性があります。最新の情報はトップページよりご覧ください。');
          router.push(props.errorPageUrl);
          break;
        default:
          router.push(props.errorPageUrl);
          break;
      }
    });
}
</script>

<template>
  <h2 class="title_sub1">パスワードの再設定</h2>
  <div class="form-group">
    <p class="com_center1s">新しいパスワードをご入力いただき、<br>パスワードを再設定してください。</p>
    <div class="com_show_hide_password1 com_mgt15 com_mgt10s">
      <Password v-model="input.password"
        placeholder="新しいパスワード" :error="errorMessage.password !== ''"/>
    </div>
    <div class="com_validate_msg1 error" v-if="errorMessage.password">
      {{ errorMessage.password }}
    </div>
    <div class="com_show_hide_password1 com_mgt15 com_mgt10s">
      <Password v-model="input.password_confirm"
        placeholder="新しいパスワード（確認用）" :error="errorMessage.password_confirm !== ''"/>
    </div>
    <div class="com_validate_msg1 error" v-if="errorMessage.password_confirm">
      {{ errorMessage.password_confirm }}
    </div>
    <button type="button" name="" class="btn com_btn3 cl1" @click="onClickUpdateButton">更新</button>
  </div>
</template>

<style>
.com_validate_msg1.error {
  white-space: pre-wrap;
}
</style>